import { render } from "./bsHome.vue?vue&type=template&id=082ac06b"
import script from "./bsHome.vue?vue&type=script&lang=js"
export * from "./bsHome.vue?vue&type=script&lang=js"

import "./bsHome.vue?vue&type=style&index=0&id=082ac06b&scope=true&lang=css"

import exportComponent from "D:\\WORK\\GitLab管理\\My-Lab\\VUE-H5\\front-end-project-file-management\\vue-h5-宝山-第八次代表大会\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__